module.exports = __webpack_public_path__ + "static/media/analogdevices.4b355f44.png";